import { useTranslation } from 'react-i18next';
import { Locale } from '@ivario-arc/shared/src/types/locales';
import { publicApiClient } from '@src/api/client';
import { toSupportedLocale } from '@utils/language';

/**
 * Fetches the announcement bar content for the active frontend locale.
 *
 * Uses the public API client (no auth middleware) because the login/registration
 * page shows an announcement before the user is authenticated.
 */
export const useAnnouncement = () => {
  const { i18n } = useTranslation();
  const locale = toSupportedLocale(i18n.language) ?? Locale.DE;

  return publicApiClient.useQuery('get', '/api/announcement', {
    params: { query: { locale } },
  });
};
